var map = {
	"./bmp": 52,
	"./bmp.js": 52,
	"./gif": 53,
	"./gif.js": 53,
	"./jpg": 54,
	"./jpg.js": 54,
	"./png": 55,
	"./png.js": 55,
	"./psd": 56,
	"./psd.js": 56,
	"./svg": 57,
	"./svg.js": 57,
	"./tiff": 58,
	"./tiff.js": 58,
	"./webp": 59,
	"./webp.js": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 280;